import type { ICmsSubscriptionService } from "./cms-subscription.service.interface";
import type { ICmsSubscription } from "./entities/cms-subscription/cms-subscription.entity.interface";
import { CmsSubscriptionRepository } from "./repositories/cms-subscription.repository";
import type { ICmsSubscriptionRepository } from "./repositories/cms-subscription.repository.interface";

export class CmsSubscriptionService implements ICmsSubscriptionService {
  constructor(private readonly _repository: ICmsSubscriptionRepository = new CmsSubscriptionRepository()) {}

  public getOrderedSubscriptions(): Promise<ICmsSubscription[]> {
    return this._repository.getOrderedSubscriptions();
  }
}
